import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Layout, Button } from "element-react";
import Paging from 'components/Paging'
import NoDataPicture from 'components/NoDataPicture'
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import PagingContent from 'components/PagingContent'
import img from "images/index/soldier01.png";
import { showhtml } from 'utils/methods'

require("./index.scss");

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: 1,
      current: 1,
      size: 10,
      data: '',
      list: [
        {
          type: '动态资讯',
          title: '中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议',
          img: img,
          txt: '中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议中国青年报：退役军人事务部与10家银行签署拥军优抚合作协议',
          source: '退役军人事务部',
          time: '2018-12-20',
        }
      ]
    };
  }


  componentWillMount() {
    // 当前页刷新时获取路由参数值
    var search = this.props.location.search;
    var index = search.lastIndexOf("\=");
    var searchVal = search.substring(index + 1, search.length);
    this.getList(searchVal)

    // 路由变化时获取路由参数值
    this.props.history.listen((val) => {
      let index = val.search.lastIndexOf("\=");
      let searchVal = val.search.substring(index + 1, val.search.length);
      this.getList(searchVal)
    })

  }

  getList(val) {
    let { type, current, size } = this.state;
    let params = {
      searchMessage: val
    };
    return Http.get(Request.searchByParam(), params, obj => {
      console.log('obj', obj.content);
      if (obj.content != '') {
        this.setState({
          data: obj.content
        })
      } else {

      }
    });
  }

  goDetails = (id, categoryName) => {
    if (categoryName == "通知公告" || categoryName == "热点新闻" || categoryName == "军人资讯" || categoryName == "其他") {
      this.props.history.push('/entrance/InformationDetails?' + id)
    }
    if (categoryName == "国家政策" || categoryName == "地方政策" || categoryName == "法律法规" || categoryName == "政策解读") {
      this.props.history.push('/entrance/PolicyDetails?' + id)
    }
    if (categoryName == "退役军人风采" || categoryName == "最美退役军人" || categoryName == "精彩纪录片" || categoryName == "军队达人" || categoryName == "军队生活") {
      this.props.history.push('/entrance/soldierDetail?' + id)
    }
  }


  render() {
    let { list, data } = this.state;
    return (
      <div className="container clear">
        <div className="text_search_title"><span>搜索结果</span></div>
        <ul className="text_search_list">
          {
            data && data.map((item, index) => {
              return (
                <li key={index}>
                  <div className="clear">
                    <span className="sign_span">{item.categoryName == '' ? "动态资讯" : item.categoryName}</span>
                    <span className="title_span" onClick={() => { this.goDetails(item.id, item.categoryName) }}>{showhtml(item.title)}</span>
                  </div>
                  <div className="text_search_cont clear">
                    <div className="text_search_img">
                      {item.image != "" ? (
                        <img src={item.image} />
                      ) : (
                          <NoDataPicture />
                        )}
                    </div>
                    <div className="text_search_txt">
                      <div className="cont_txt">{showhtml(item.description)}</div>
                      <div className="source_txt">{item.fromurl}&nbsp; &nbsp;&nbsp; &nbsp;{item.updateTime}</div>
                    </div>
                  </div>
                </li>
              )
            })
          }
        </ul>
      </div>

    );
  }
}
